module.exports = __webpack_public_path__ + "static/media/miMatic.db13df23.png";